import { CommonModule } from '@angular/common';
import { CreditCardOfferComponent } from './credit-card-offer.component';
import { HmfButtonComponent, HmfTextLinkComponent } from '@dsg-tech/homefield-angular';
import { HomefieldIconLibraryModule } from '@dsg-tech/homefield-angular-icons';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [
		CreditCardOfferComponent
	],
	exports: [
		CreditCardOfferComponent
	],
	imports: [
		CommonModule,
		HmfButtonComponent,
		HmfTextLinkComponent,
		HomefieldIconLibraryModule
	]
})
export class CreditCardOfferModule {}
